import { apiClient } from './client'
import endpoints from './endpoints'
import { unwrapSingle } from './normalize'

export default async function compareGpsData({ farm, file, eventEndDate, eventStartDate } = {}) {
  const formData = new FormData()
  formData.append('file', file)
  formData.append('farmId', farm.id)
  formData.append('eventStartDate', eventStartDate)
  formData.append('eventEndDate', eventEndDate)
  const response = await apiClient.post(endpoints.compareGpsData, formData)
  return unwrapSingle(response)
}
